import * as React from "react";
import { type AspectRatio } from "../AspectRatioContainer/lib";
import BunnyVideo from "./Bunny/component";
import { isBunnyEmbedUrl } from "./Bunny/lib";
import HtmlVideo from "./HTML/component";
import VideoJs from "./VideoJs/component";
import { isBunnyUrl } from "./VideoJs/lib";
import VimeoVideo from "./Vimeo/component";
import { isVimeoURL } from "./Vimeo/lib";
import VzaarVideo from "./Vzaar/component";
import { isVzaarURL } from "./Vzaar/lib";
import WistiaVideo from "./Wistia/component";
import { isWistiaURL } from "./Wistia/lib";
import YouTubeVideo from "./YouTube/component";
import { isYouTubeURL } from "./YouTube/lib";

import "./style.less";

export interface VideoBase {
  showControls?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  mute?: boolean;
}

export type VideoPropsBase = VideoBase & {
  allowFullScreen?: boolean;
  aspectRatio?: AspectRatio;
  className?: string;
  isBackground?: boolean;
  posterUrl?: string | null;

  onStartPlay?: () => void;
};

export type VideoProps = VideoPropsBase & {
  isAlwaysAvailable?: boolean;
  shouldTrack?: boolean; // currently implemented for Bunny player only
  url?: string;
};

class Video extends React.PureComponent<VideoProps> {
  public render() {
    const props = this.props;

    if (isBunnyEmbedUrl(props.url)) return <BunnyVideo {...props} />;
    if (isBunnyUrl(props.url)) return <VideoJs {...props} />;
    if (isWistiaURL(props.url)) return <WistiaVideo {...props} />;
    if (isYouTubeURL(props.url)) return <YouTubeVideo {...props} />;
    if (isVimeoURL(props.url)) return <VimeoVideo {...props} />;
    if (isVzaarURL(props.url)) return <VzaarVideo {...props} />;

    return <HtmlVideo {...props} />;
  }
}

export default Video;
